<template>
  <div>
    <m-card-list
      id-key
      title="Daftar Anggota"
      add
      @search="
        search => {
          textSearch = search;
          load();
        }
      "
      @add="add"
      :items="items"
    >
      <template v-slot:items="{ item }">
        <v-row class="mx-3 mb-2">
          <v-col class="py-0" cols="12" md="3" sm="3">
            <span class="font-weight-bold primary--text">{{ pVal(item, "name") }}</span>
            {{ pVal(item, "email") }}
          </v-col>
          <v-col class="py-0" cols="12" md="3" sm="3">
            <p class="caption my-0 py-1 grey--text align-left">Peran</p>
            <v-chip
              class="my-1"
              v-if="item.perankelasku.length !== 0"
              outlined
              small
              :color="
                item.perankelasku[0].grup.id == 8
                  ? 'success'
                  : item.perankelasku[0].grup.id == 3
                  ? 'orange white--text'
                  : 'grey white--text'
              "
              >{{ item.perankelasku[0].grup.keterangan }}</v-chip
            >
          </v-col>
          <v-col class="py-0" cols="12" md="5" sm="5">
            <div v-if="item.kecamatan" class="mt-2">
              <span class="font-weight-bold primary--text">
                {{ pVal(item.kecamatan.kota.propinsi, "keterangan") }} </span
              >,
              <span class="teal--text">{{ pVal(item.kecamatan.kota, "keterangan") }}</span>
              <p class="orange--text">Kec. {{ pVal(item.kecamatan, "keterangan") }}</p>
            </div>
          </v-col>
          <v-col class="py-0" cols="12" sm="1" md="1" lg="1" xl="1">
            <m-button
              class="ma-1 elevation-0"
              style="width :25px; height:25px"
              fab
              x-small
              icon="mdi-close"
              :large="false"
              color="error"
              dark
              action="deleteUser"
              @deleteUser="deleteUser(item)"
            ></m-button>
          </v-col>
        </v-row>
        <v-divider />
      </template>
    </m-card-list>

    <ChangeDlg ref="dlg" />
  </div>
</template>

<script>
import ChangeDlg from "../../kelas/components/FormPeserta.vue";

export default {
  components: {
    ChangeDlg
  },
  props: {
    items: {
      type: Array,
      default: () => []
    },
    group: {
      type: Object,
      default: null
    }
  },

  data() {
    return {};
  },
  computed: {},
  methods: {
    add() {
      this.$refs.dlg.open(this.group).then(() => {
        this.$emit("load");
      });
    },
    deleteUser(user) {
      var listUser = [];
      listUser.push(user);
      this.$confirm(
        `Apakah Anda yakin akan mengeluarkan pengguna terpilih dari Kelompok ini ?<br>
        <div class="mt-2 title grow text-center">

        </div>`
      )
        .then(() =>
          this.$store.dispatch("kelas/dropKandidat", {
            instansi_id: this.instansi_id,
            diklat_id: this.diklat_id,
            kelas_id: this.$route.params.kelas_id,
            kelas_modul_id: this.group.kelas_modul_id,
            grouping_id: this.group.kelas_gruping_id,
            group_id: this.group.id,
            obj: listUser
          })
        )
        .then(res => {
          if (res.status == 201) {
            return this.$info("Pengguna terpilih berhasil dikeluarkan dari kelompok");
          }
        })
        .then(() => this.$emit("load"))
        .catch(e => e);
    }
  }
};
</script>
